module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a3a4676","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Footer/index.vue
// module id = 245
// module chunks = 0